// removed by extract-text-webpack-plugin
module.exports = {"home":"home__1I2EN","grid":"grid__1GkVg","solved":"solved__1aiRP","notSolved":"notSolved__1ISw0","grid__box":"grid__box__1YMv1","chooser":"chooser__XwN2a","chooser__input":"chooser__input__21G9h","button":"button__4T10E","notification":"notification__z7_a7"};


//////////////////
// WEBPACK FOOTER
// ./components/home/style.css
// module id = HVeQ
// module chunks = 2